// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "mainSite." + ({"3543":"gallery","8792":"main"}[chunkId] || chunkId) + "." + {"2867":"9e14d01b2c65d3ac8e0b","3543":"6e4a1f1f2735adc0b739","8792":"d85e0ecc772ad8085161"}[chunkId] + ".css";
};